module.exports = __webpack_public_path__ + "img/product_icon.aa6ea82f.png";